import { IngredientsUI } from "./IngredientsUI";
import { StandardProps } from "../componentMap";
import { Product, Variant } from "../../types/types";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { useSkinMatchStatus } from "../../hooks/useSkinMatch/useSkinMatch";

type EAN_NOT_FOUND = "EAN_NOT_FOUND";

const EAN_NOT_FOUND = "EAN_NOT_FOUND";

function isChanelProduct(product: Product): boolean {
  return product?.brand?.name === "CHANEL";
}

export function getEan(variant: Variant): string {
  const { consumerBarcodes } = variant;
  if (consumerBarcodes) {
    const { ean13 = [], upc12 = [], ean8 = [] } = consumerBarcodes;
    if (ean13.length === 0 && upc12.length === 0 && ean8.length === 0) {
      return EAN_NOT_FOUND;
    }
    return ean13[0] || upc12[0] || ean8[0] || EAN_NOT_FOUND;
  }
  return EAN_NOT_FOUND;
}

export function Ingredients({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) {
  const { variant } = useVariant(product);
  const ean = getEan(variant);

  const skinMatchLookUpBaseUrl = runtimeConfig?.skinMatchLookUpBaseUrl;
  const skinMatchLookUpData = useSkinMatchStatus(ean, skinMatchLookUpBaseUrl);
  if (
    skinMatchLookUpData &&
    skinMatchLookUpData.status == "Done" &&
    skinMatchLookUpData.data.skinMatchStatus
  ) {
    const { id: variantId } = variant;
    const pimProductId = product?.aliases?.pimProductId;
    const isChanel = isChanelProduct(product);
    const skinMatchIngredientBaseUrl =
      runtimeConfig?.skinMatchIngredientBaseUrl;
    if (!variant) return null;
    return (
      ean !== EAN_NOT_FOUND &&
      !isChanel && (
        <IngredientsUI
          ean={ean}
          skinMatchLookUpData={skinMatchLookUpData}
          skinMatchIngredientBaseUrl={skinMatchIngredientBaseUrl}
          pimProductId={pimProductId}
          variantId={variantId}
        />
      )
    );
  } else {
    return null;
  }
}
